export default __webpack_public_path__ + "static/media/gangdonggu-seongnaedong-station-activation-3.23d75ffd.jpg";